import { t as tEscape, tDangerouslyUnescapedValues as tNoEscape } from './i18n'

// Re-export these just to save our sanity
export { tDangerouslyUnescapedValues, DateTime } from './i18n'

// NB: We do not need to escape values when interpolating strings into
// React components, because React does it for us, and we don't want to
// double-escape
export const t = tNoEscape
export const tWithEscape = tEscape